/**
 * script used to fix the issue where the search suggestion div elements
 * are duplicated on the mobile and gets hidden. This issue is only happening on iOS devices.
 * this also positions the mobile search input correctly.
 *
 */

;(function () {
  const body = document.body

  function positionMobileSearchInput() {
    const suggestionMobileTopPanels = body.querySelector(
      '.boost-pfs-search-suggestion-mobile-top-panel'
    )
    const headerSearchForm = body.querySelector('form.header-search__form')

    if (suggestionMobileTopPanels && headerSearchForm) {
      const { top } = headerSearchForm.getBoundingClientRect()
      suggestionMobileTopPanels.style.top = `calc(${top}px - (64px - 4rem) / 2)`
    }
  }

  function removeDuplicateElements() {
    const elements = body.querySelectorAll(
      '#boost-pfs-search-suggestion-mobile, .boost-pfs-search-suggestion-mobile-overlay, .boost-pfs-search-suggestion-mobile-top-panel, #boost-pfs-search-suggestion-mobile .boost-pfs-search-suggestion'
    )
    if (elements.length > 4) {
      const elementsToRemove = [elements[3], ...Array.from(elements).slice(5)]
      elementsToRemove.forEach((element) => {
        element.remove()
      })
    }
  }

  const mutationObserver = new MutationObserver(() => {
    const isMobile = window.innerWidth < 768
    if (!isMobile) {
      return
    }

    removeDuplicateElements()
    positionMobileSearchInput()
  })
  mutationObserver.observe(body, {
    childList: true,
    attributes: true,
  })
})()
